import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useFeatures } from '@atc/features';
import { sendClick } from 'reaxl-analytics';
import { ownerText } from 'reaxl-analytics-handlers';
import { Button, Glyphicon, Link, IconButton } from 'reaxl';
import smsLink from 'sms-link';

/**
 *  Provides a link to text Dealer
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function OwnerTextCTA(_ref) {
  let {
    analyticsData,
    buttonBsStyle = 'primary',
    className,
    iconClassName,
    textClickHandler = () => {},
    label = 'Text Dealer Anonymously',
    phoneNumber,
    textBody = '',
    uiContext = 'button',
    ...rest
  } = _ref;
  const {
    text: [isTextEnabled]
  } = useFeatures(['text']);
  const smsHref = smsLink({
    phone: phoneNumber,
    body: textBody
  });
  const handleClick = event => {
    event.stopPropagation();
    sendClick(ownerText, event, analyticsData);
    textClickHandler(phoneNumber);
  };
  if (!isTextEnabled || !smsHref) {
    return null;
  }
  if (['iconbutton', 'iconbutton-horizontal'].includes(uiContext)) {
    return /*#__PURE__*/_jsx(IconButton, {
      "data-cmp": "ownerTextCTA",
      glyph: "commenting-o",
      className: className,
      label: label,
      layout: uiContext === 'iconbutton' ? 'stacked' : 'horizontal',
      onClick: handleClick,
      href: smsHref,
      rel: "nofollow noopener",
      size: uiContext === 'iconbutton' ? 'large' : 'medium',
      target: "_blank"
    });
  }
  if (uiContext === 'text') {
    return /*#__PURE__*/_jsx(Link, {
      "data-cmp": "ownerTextCTA",
      href: smsHref,
      className: className,
      onClick: handleClick,
      label: label,
      "aria-label": "Text"
    });
  }
  delete rest.phoneNumber;
  delete rest.textBody;
  delete rest.uiContext;
  return /*#__PURE__*/_jsxs(Button, {
    "data-cmp": "ownerTextCTA",
    href: smsHref,
    className: className,
    bsStyle: buttonBsStyle,
    onClick: handleClick,
    "aria-label": "Text",
    ...rest,
    children: [/*#__PURE__*/_jsx(Glyphicon, {
      glyph: "commenting-o",
      className: clsx({
        'margin-right-2': buttonBsStyle !== 'link'
      }, iconClassName),
      "aria-hidden": "true"
    }), label]
  });
}
export default /*#__PURE__*/memo(OwnerTextCTA);